import React, { Component, PropTypes } from 'react';
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth';
import { connect } from 'react-redux';

class SurveyRedirect extends React.Component {

  render(){

    return(
      <div className="survey-redirect profile-inner">
        <div className="collage-wrapper">
          <div className="survey-banner">
            <div className="survey-bannerText global-banner-text">
              <h2>Share your feedback & win a prize...</h2>
              <p className="survey-bannerTextTag tag">
                We value your insight!
              </p>
            </div>
          </div>
          <div className="survey-body">
            <div className="survey-body-inner">
              <div className="survey-content">
                <h1 className="survey-header">
                  Thank you for being a WorldWideWomen Tester!
                </h1>
                <p>Your feedback will help us make WorldWideWomen a valuable resource for you and all of our users around the world. As a thank you for becoming a member, exploring our website, and sharing your thoughts, we will enter your name in a drawing to win $1,000 for your favorite charity. The winner will be selected on April 1st and only WorldWideWomen members are eligible. Feel free to email additional thoughts to us at <a href="mailto:info@worldwidewomen.co">info@worldwidewomen.co</a>. Thank you for taking the time to respond to our survey!</p>

                <div className="survey-button-wrapper"><a className="survey-button" href="https://www.surveymonkey.com/r/worldwidewomen" target="_blank">Take our survey!</a></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

// I have not used connect decorator as it does not seem to need
// whole state. You may also add connect decorator if you need access
// to state before actually redirecting.
export default UserIsAuthenticated(UserIsVerified(SurveyRedirect))



// WEBPACK FOOTER //
// ./src/containers/SurveyRedirect.jsx